export default "__VITE_ASSET__BLo9_bzt__"